function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { disableAllElementsFocusInWrapper, useFocusWrapper } from "../../../hooks/useFocusWrapper";
import useReactSlickSlider from "../../../hooks/useReactSlickSlider";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "m20.727 16.693-6.034 6.02a.997.997 0 0 1-1.4 0 .98.98 0 0 1 0-1.386L18.643 16l-5.34-5.326a.98.98 0 0 1 0-1.386.997.997 0 0 1 1.4 0l6.034 6.02a.974.974 0 0 1 0 1.386z"
  }));
};
ArrowSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32"
};
var PauseSvg = function PauseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 3a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V3Zm-8 0a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V3Z",
    fill: "#000",
    fillOpacity: ".7"
  }));
};
PauseSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "16",
  fill: "none"
};
var PlaySvg = function PlaySvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.752 1.44 22.26 7.568a.5.5 0 0 1 0 .863l-10.508 6.13A.5.5 0 0 1 11 14.13V1.871a.5.5 0 0 1 .752-.432Z",
    fill: "#000",
    fillOpacity: ".7"
  }));
};
PlaySvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "16",
  fill: "none"
};
import Slide from "./components/Slide";
import { NextArrowButton, PlayIcon, PrevArrowButton, ProgressBar, SliderDot, SliderDots, SliderIndicators, StyledSlider } from "./FullWidthSliderMol.styled";
var numberOfVisibleSlides = 1;
function FullWidthSliderMol(_ref) {
  var slides = _ref.slides,
    autoPlay = _ref.autoPlay,
    _ref$autoplaySpeed = _ref.autoplaySpeed,
    autoplaySpeed = _ref$autoplaySpeed === void 0 ? 5000 : _ref$autoplaySpeed,
    slideTitle = _ref.slideTitle;
  var sliderRef = useRef(null);
  var sliderIndicatorsRef = useRef(null);
  var _useState = useState(!!autoPlay),
    _useState2 = _slicedToArray(_useState, 2),
    isPlayed = _useState2[0],
    setIsPlayed = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSlideIndex = _useState4[0],
    setCurrentSlideIndex = _useState4[1];
  var isLargeUp = useBreakpoint("large");
  var _useFocusWrapper = useFocusWrapper(),
    focusWrapperRef = _useFocusWrapper.focusWrapperRef,
    isWrapperFocused = _useFocusWrapper.isWrapperFocused,
    handleOnFocusWrapper = _useFocusWrapper.handleOnFocusWrapper,
    handleOnBlurWrapper = _useFocusWrapper.handleOnBlurWrapper;
  var _useReactSlickSlider = useReactSlickSlider(sliderRef, focusWrapperRef, !!isWrapperFocused, slides.length),
    handleSliderAfterChange = _useReactSlickSlider.handleSliderAfterChange,
    sliderUpdateProps = _useReactSlickSlider.sliderUpdateProps;
  var playSlider = function playSlider() {
    var _sliderRef$current;
    (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 || _sliderRef$current.slickPlay();
    setIsPlayed(true);
  };
  var pauseSlider = function pauseSlider() {
    var _sliderRef$current2;
    (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 || _sliderRef$current2.slickPause();
    setIsPlayed(false);
  };
  var handlePlayButtonClick = function handlePlayButtonClick() {
    if (isPlayed) {
      pauseSlider();
    } else {
      playSlider();
    }
  };
  useEffect(function () {
    disableAllElementsFocusInWrapper(sliderIndicatorsRef.current);
  }, []);
  var playTitle = isPlayed ? slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.pause : slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.play;
  return /*#__PURE__*/React.createElement("div", {
    ref: focusWrapperRef,
    onFocus: function onFocus() {
      pauseSlider();
      handleOnFocusWrapper();
    },
    onBlur: function onBlur(event) {
      playSlider();
      handleOnBlurWrapper(event);
    }
  }, /*#__PURE__*/React.createElement(StyledSlider, _extends({
    ref: sliderRef,
    slidesToShow: numberOfVisibleSlides,
    slidesToScroll: numberOfVisibleSlides,
    arrows: isLargeUp,
    prevArrow: /*#__PURE__*/React.createElement(PrevArrowButton, {
      tabIndex: -1,
      $isPrevIcon: true,
      title: slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.previous,
      "aria-label": slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.previous
    }, /*#__PURE__*/React.createElement(ArrowSvg, null)),
    nextArrow: /*#__PURE__*/React.createElement(NextArrowButton, {
      tabIndex: -1,
      title: slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.next,
      "aria-label": slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.next
    }, /*#__PURE__*/React.createElement(ArrowSvg, null)),
    dots: true,
    appendDots: function appendDots(dots) {
      return /*#__PURE__*/React.createElement(SliderIndicators, {
        ref: sliderIndicatorsRef
      }, /*#__PURE__*/React.createElement(SliderDots, null, dots), /*#__PURE__*/React.createElement(PlayIcon, {
        onClick: handlePlayButtonClick,
        role: "button",
        title: playTitle,
        "aria-label": playTitle
      }, isPlayed ? /*#__PURE__*/React.createElement(PauseSvg, null) : /*#__PURE__*/React.createElement(PlaySvg, null)));
    },
    customPaging: function customPaging(index) {
      var isActive = index === currentSlideIndex;
      var dotTitle = isActive ? slideTitle === null || slideTitle === void 0 ? void 0 : slideTitle.active : "".concat(slideTitle !== null && slideTitle !== void 0 && slideTitle.dot ? slideTitle.dot : "", " ").concat(index + 1);
      return /*#__PURE__*/React.createElement(SliderDot, {
        $isActive: isActive,
        title: dotTitle,
        "aria-label": dotTitle
      }, isActive ? /*#__PURE__*/React.createElement(ProgressBar, {
        $isStopped: !isPlayed,
        $time: autoplaySpeed
      }) : null);
    },
    beforeChange: function beforeChange(_currentIndex, nextIndex) {
      return setCurrentSlideIndex(nextIndex);
    },
    autoplay: isPlayed,
    centerPadding: "0",
    autoplaySpeed: autoplaySpeed,
    centerMode: true,
    pauseOnHover: false,
    afterChange: handleSliderAfterChange
  }, sliderUpdateProps), slides.map(function (slide) {
    return /*#__PURE__*/React.createElement(Slide, {
      key: slide.key
    }, slide.slide);
  })));
}
export default FullWidthSliderMol;